import { normalizeTwoWords } from '../../../shared/utils/stringUtilities';
import './follows.scss';

interface FooterInterface {
    nombreCategoria: string;
    referenciaSubcategorias: {
        tituloPrincipal: string;
        link: string;
        slug: string;
        nombreSubcategoria: string;
        tipoCampo: string;
    }[];
}

const Follows = (props: {
    query: FooterInterface;
    inverse?: boolean;
    noTitle?: boolean;
}) => {
    const { query, inverse = false, noTitle = false } = props;

    const drawSocialIcons = (type: boolean, value: any) => {
        if (type) {
            if (value.nombreSubcategoria.includes('1')) {
                return value.nombreSubcategoria.replace('1', '');
            } else {
                return value.nombreSubcategoria.concat('', '1');
            }
        }

        return value.nombreSubcategoria;
    };

    return (
        <div className="m-follows">
            {!noTitle && <span>{query.nombreCategoria}</span>}
            <ul>
                {query.referenciaSubcategorias.map((val: any, key) => (
                    <li
                        key={key}
                        className={`gtm${normalizeTwoWords(
                            val.tituloPrincipal
                        )}`}
                    >
                        {val.tituloPrincipal === 'icon-spotify' ||
                        val.tituloPrincipal === 'icon-tiktok' ? (
                            <div className="m-follows__container">
                                <a
                                    href={val.link}
                                    className={`gtm${normalizeTwoWords(
                                        val.tituloPrincipal
                                    )}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={val.tituloPrincipal}
                                    title={val.tituloPrincipal}
                                >
                                    <i
                                        className={`gtm${normalizeTwoWords(
                                            val.tituloPrincipal
                                        )} ${drawSocialIcons(inverse, val)}`}
                                    />
                                </a>
                            </div>
                        ) : (
                            <a
                                href={val.link}
                                className={`gtm${normalizeTwoWords(
                                    val.tituloPrincipal
                                )}`}
                                target="_blank"
                                rel="noreferrer"
                                aria-label={val.tituloPrincipal}
                                title={val.tituloPrincipal}
                            >
                                <i
                                    className={`gtm${normalizeTwoWords(
                                        val.tituloPrincipal
                                    )} ${drawSocialIcons(inverse, val)}`}
                                />
                            </a>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Follows;
